/**
 * Motivos de logout forçado e a tradução deles para a URL do /login.
 *
 * Dois caminhos deslogam o usuário à força: o middleware (server) e o
 * useAuthSession (client, via handleForcedLogout). Ambos precisam aterrissar em
 * `/login?reason=...` — a página de login só mostra mensagem quando o motivo
 * vem na URL; motivo que fica só em store é logout mudo (o usuário reloga em
 * círculo sem saber por quê).
 */
export type ForcedLogoutReason = 'inactive' | 'deleted' | 'missing'

export const FORCED_LOGOUT_REASON_PARAM: Record<ForcedLogoutReason, string> = {
	missing: 'user_not_found',
	inactive: 'user_inactive',
	deleted: 'user_deleted',
}

export function forcedLogoutLoginUrl(reason: ForcedLogoutReason): string {
	return `/login?reason=${FORCED_LOGOUT_REASON_PARAM[reason]}`
}

/** Mensagens exibidas pelo /login para cada `?reason=` conhecido. */
export const LOGOUT_REASON_MESSAGES: Record<string, string> = {
	user_not_found: 'Não encontramos sua conta no Turing. Fale com um administrador para liberar seu acesso.',
	user_inactive: 'Sua conta está inativa no Turing. Fale com um administrador para reativar seu acesso.',
	user_deleted: 'Sua conta foi removida do Turing. Fale com um administrador se isso for um engano.',
}
